//Search end points Error messages
export const assets3DSearchApiErrorMsg =
  "Error retrieving data from 3D Assets search API : ";
export const productsSearchApiErrorMsg =
  "Error retrieving data from Product search API : ";
export const assetsAndProductsSearchApiErrorMsg =
  "Error retrieving data from Assets / Product search API : ";

//Tags
export const tagsApiErrorMsg = "Error retrieving data from Tags API : ";
export const tagsApplyToAllAssetsErrorMsg =
  "Error applying Tags to all 3D assets";

//Get-Asset-By-UUID
export const assetByUUIDErrorMsg = "Error fetching assets by UUID : ";
export const getCreatedAssetsErrorMsg = "Error retrieving saved assets : ";

//Get Product by UUID
export const productByUUIDErrorMsg =
  "Error fetching Product by UUID on results page : ";

//Creating 3D Assets
export const createAssetsErrorMsg = "Error creating 3D assets : ";

//Manage asset Details
export const manageAssetDetailsRetrieveErrorMsg =
  "Error retrieving Asset details";

// Manage product Details
export const manageProductDetailsRetrieveErrorMsg =
  "Error retrieving Product details";
